export class CompSearchJuristictionSingleTable {
  key: string;
  tableName: string;
  position: number;
}
